namespace GeniuzPOS.AdvPromo {
    export enum PromoDayChFg {
        alldy = 0,
        chday = 1
    }
    Serenity.Decorators.registerEnumType(PromoDayChFg, 'GeniuzPOS.AdvPromo.PromoDayChFg');
}
